<template>
    <div id="tarefa">

        <my-tour v-if="showItem" :steps="steps" name="steps-gerenciamentoLead"></my-tour>
        <section id="content" class="section">
            <div class="container">
            <TituloPagina titulo="Histórico do cliente" />
                <div class="row">
                    <!--<div class="col s12 m6 l6">
                        <h5 class="breadcrumbs-title">Gerenciamento de Lead</h5>
                    </div>-->
                    <div class="col s12 m6" v-if="checaMostrarBotoes()">
                        <!-- <button
                            class="ml-2 btn gradient-45deg-deep-orange-orange waves-effect waves-light right"
                            @click="abreModalLost()"
                            v-if="checaCargoUsuario([cargoDono, cargoCorretor, cargoLider])"
                        >
                            NEGATIVADO
                            <i class="material-icons right">clear</i>
                        </button>
                        <button
                            class="btn gradient-45deg-indigo-blue waves-effect waves-light right"
                            @click="abreModalCold()"
                            v-if="checaCargoUsuario([cargoDono, cargoCorretor, cargoLider])"
                        >
                            EM ESPERA
                            <i class="material-icons right">block</i>
                        </button> -->
                    </div>
                </div>
                <div id="container">
                    <div class="row">
                        <div class="col s12 l3">
                            <InformacoesAdicionais :showButtons="checaCargoUsuario([cargoDono, cargoCorretor, cargoLider])" :modalLost="abreModalLost" :modalCold="abreModalCold" @atualiza="atualizaPedido($event)" :pedido="item" :showItem="showItem"/>
                        </div>
                        <div class="col s12 l9">
                            <!--<div class="row">
                                <div class="col m12">
                                    <ul class="tabs tabs-fixed-width tab-demo z-depth-1" ref="tab">
                                        <li class="tab col s4"><a class="active" href="#acompanhamento">Acompanhamento</a></li>
                                        <li class="tab col s4" v-if="checaCargoUsuario([cargoDono, cargoCorretor, cargoLider, cargoGerente, cargoEspecialista])">
                                            <a href="#tarefas">Tarefas</a>
                                        </li>
                                        <li class="tab col s4" v-show="true"><a href="#anexo">Anexos</a></li>
                                    </ul>
                                </div>
                            </div>-->
                            <div class="row">
                                <div class="col m12">
                                    <div class="row ">
                                        <div id="acompanhamento" class="col s12 active card">
                                            <h4 class="header2">ACOMPANHAMENTO</h4>
                                           <Acompanhamento @atualiza="atualizaPedido($event)" :pedido="item" v-if="showItem" :list="acompanhamentoListagem" />
                                        </div>
                                        <div id="tarefas" class="col s12 card" v-if="checaCargoUsuario([cargoDono, cargoCorretor, cargoLider, cargoGerente, cargoEspecialista], [cargoDono, cargoCorretor, cargoLider])">
                                            <h4 class="header2">TAREFAS</h4>
                                            <Tarefas @atualiza="atualizaPedido($event)" :pedido="item" v-if="showItem" />
                                        </div>
                                        <div id="anexo" class="col s12 card">
                                            <h4 class="header2">ANEXO DE DOCUMENTO</h4>
                                            <Anexo :pedido="item" v-if="showItem" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <!-- Modal Congelar -->
        <div id="modal1" class="modal modal-fixed-footer" style="z-index: 999">
            <div class="modal-content pt-0 pl-0 pr-0">
                <div class="modal-header">
                    <div class="row pt-2">
                        <div class="col m12">
                            <h4 class="ml-2 header2">Cliente em espera</h4>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <p class="ml-2">Informe até quando é para o cliente ficar em espera:</p>
                    <div class="input-field col m6">
                        <datepicker v-model="congelar.dataRetorno" format="DD/MM/YYYY" language="pt-br" name="filtroDataInicio" placeholder="Data de retorno" ></datepicker>
                    </div>
                </div>
                <div class="row">
                    <div class="input-field col m12">
                        <textarea v-model="congelar.observacao" id="cold_observacao" class="materialize-textarea"></textarea>
                        <label for="cold_observacao">Observação</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer grey lighten-3">
                <button class="modal-action modal-close btn waves-effect waves-light grey darken-1">Cancelar</button>
                <button @click="congelarPedido()" class="btn">Em espera</button>
            </div>
        </div>

        <!-- Modal lost -->
        <div id="modalLost" class="modal modal-fixed-footer">
            <div class="modal-content pt-0 pl-0 pr-0">
                <div class="modal-header">
                    <div class="row pt-2">
                        <div class="col m12">
                            <h4 class="ml-2 header2">Mudar estágio para perdido</h4>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col m6">
                        <label for="lost_motivo">Motivo</label>
                        <select class="browser-default" v-model="lost.motivo" id="lost_motivo">
                            <option value="" disabled selected>Selecione ...</option>
                            <option value="1">Não concorda com custo</option>
                            <option value="2">Fechou com outra corretora</option>
                            <option value="3">Fechou com banco</option>
                            <option value="4">Não gostou dos benefícios</option>
                            <option value="5">Já tem outra corretora</option>
                            <option value="6">Não tem interesse</option>
                            <option value="7">Sem retorno do cliente</option>
                            <option value="8">Renovou com o corretor da apólice</option>
                            <option value="9">Desistiu do Seguro</option>
                            <option value="10">Somente Cotação</option>
                            <option value="11">Telefone inválido</option>
                            <option value="12">Não teve aceitação nas Seguradoras</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="input-field col m12">
                        <textarea v-model="lost.observacao" id="lost_observacao" class="materialize-textarea"></textarea>
                        <label for="lost_observacao">Observação</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer grey lighten-3">
                <button class="modal-action modal-close btn waves-effect waves-light grey darken-1">Cancelar</button>
                <button @click="lostPedido()" class="btn">Perdido</button>
            </div>
        </div>
    </div>
</template>
<style>
    ul.tab-demo a.active {
        background-color: #00bcd42b !important;
        color: #00bcd4 !important;
        font-weight: bold !important;
    }
</style>
<script type="text/javascript">
    import Tarefas from '@/components/lead/Tarefas'
    import TituloPagina from '@/components/common/TituloPagina'
    import Acompanhamento from '@/components/lead/Acompanhamento'
    import Anexo from '@/components/lead/Anexo'
    import InformacoesAdicionais from '@/components/lead/InformacoesAdicionais'
    import CardInfo from '@/components/lead/CardInfo'
    import { get, post } from '@/helpers/api';
    // import Datepicker from 'vuejs-datepicker';
    import Datepicker from "vue2-datepicker";
    import Message from '@/helpers/message';
    import MyTour from '@/components/common/MyTour.vue';
    import ConverterHelper from '@/helpers/converter';
    import {
        ESTAGIO_PROSPECCAO,
        ESTAGIO_CHAMADA_TELEFONICA,
        ESTAGIO_PRIMEIRA_VISITA,
        ESTAGIO_EFETIVADO,
        ESTAGIO_NEGATIVADO,
        ESTAGIO_SEGUNDA_VISITA,
        ESTAGIO_EM_ESPERA,
        ESTAGIO_NEGOCIACAO,
        ESTAGIO_PERDIDO,
    } from '@/constants/pedidoEstagio.js';
    import { DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER, PARCEIRO } from '@/constants/funcionarioCargo.js';

    import { checaCargo } from '@/helpers/perfil';
    import
    {
        isMultiEmpresa
    }
    from '@/environment';
    import TourHelper from '@/helpers/tour';

    import Auth from '@/store/auth';


    export default {
        data: () => ({
            item: Object,
            showItem: false,
            congelar: {
                dataRetorno: moment().format('MM/DD/YYYY'),
                observacao: ''
            },
            lost: {
                motivo: '',
                observacao: ''
            },
            usuarioLogadoCargo: null,
            cargoDono: null,
            cargoGerente: null,
            cargoCorretor: null,
            cargoEspecialista: null,
            cargoLider: null,
            cargoParceiro: null,
            acompanhamentoListagem: [],
             steps: [
                {
                    parent: '#card-profile',
                    target: '#card-profile',
                    content: 'Podemos colocar uma foto do Lead clicando aqui, e da mesma forma alterar ela se já tiver alguma!',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        // placement: 'left',
                        menu: false
                    }
                },
                {
                    parent: '#card-actions',
                    target: '#card-actions',
                    content: 'Com esses botões é possível negativá-lo ou colocá-lo em espera a qualquer momento da esteira!',
                    params: { cargos: [DONO, CORRETOR, LIDER],
                        // placement: 'left',
                        menu: false
                    }
                },
               {
                    parent: '.collection',
                    target: '.collection',
                    content: 'As informações dele ficam aqui...',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'left',
                        menu: false
                    }
                },
                {
                    parent: '.data-criacao',
                    target: '.data-criacao',
                    content: 'Bem como a data em que ele foi cadastrado no sistema!',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'left',
                        menu: false
                    }
                },
                {
                    parent: '.edit',
                    target: '.edit',
                    content: 'e podem ser alteradas clicando neste icone!',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'right',
                        bgTransparent: true,
                        bgClass: 'color-default',
                        menu: false
                    }
                },
                {
                    parent: '#autorenew',
                    target: '#autorenew',
                    content: 'Também é possível alterar a qualquer momento o consultor responsável pelo Lead!',
                    params: { cargos: [DONO, GERENTE, ESPECIALISTA],
                        placement: 'right',
                        menu: false
                    }
                },
                {
                    parent: '#card-content',
                    target: '#card-content',
                    content: 'Podemos visualizar os produtos vinculados a este Lead! Quando ele é efetivado os icones ficam verde, quando negativa fica vermelho!',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'right',
                        menu: false
                    }
                },
                {
                    parent: '#anexo',
                    target: '#anexo',
                    content: 'E aqui colocar os anexos que forem necessários!',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'top',
                        menu: false
                    }
                },
                {
                    parent: '#acompanhamento',
                    target: '#acompanhamento',
                    content: 'Podemos ter um histórico detalhado de todas as etapas que o Lead passou!',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'bottom',
                        menu: false
                    }
                },
                 {
                    parent: '#tarefas',
                    target: '#tarefas',
                    content: 'Aqui é onde ocorre o passo a passo da esteira! Onde é colocada as informações de cada etapa, observações, datas, horarios e estados!',
                    params: { cargos: isMultiEmpresa ? [DONO, CORRETOR, LIDER] : [DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'bottom',
                        toTop: true,
                        menu: false
                    }
                    },
                    // {
                    //     parent: '#card1',
                    //     target: '#card1',
                    //     content: 'Primeiro contato telefônico do consultor com o Lead para entender um pouco da necessidade dele!',
                    //     params: { cargos: [DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    //         placement: 'bottom',
                    //         menu: false
                    //     }
                    // },
                    // {
                    //     parent: '#card2',
                    //     target: '#card2',
                    //     content: 'Obtendo sucesso no primeiro contato, o consultor parte para uma visita ao Lead para mapear junto dele sua rotina, seus gastos, sua familia, renda, etc...',
                    //     params: { cargos: [DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    //         placement: 'bottom',
                    //         menu: false
                    //     }
                    // },
                    // {
                    //     parent: '#card3',
                    //     target: '#card3',
                    //     content: 'Obtendo sucesso na visita, abre portas para negociação! Onde são feitos mais contatos e visitas para aprofundar melhor nos detalhes e entender quais produtos são o que melhor atende este Lead',
                    //     params: { cargos: [DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    //         placement: 'bottom',
                    //         menu: false
                    //     }
                    // },
                    // {
                    //     parent: '#card4',
                    //     target: '#card4',
                    //     content: 'Se ocorrer tudo bem nas negociações o Lead é efetivado e vira cliente, caso contrario ele é negativado e com a observação do consultor futuramente pode ser necessário um novo contato ou não!',
                    //     params: { cargos: [DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    //         placement: 'bottom',
                    //         menu: false
                    //     }
                    // },
                    {
                        parent: '#left-sidebar-nav',
                        target: '#removidos',
                        content: 'Para vermos os Leads que foram excluídos, basta no menu clicar em <b>Leads removidos</b>!',
                        params: { cargos: isMultiEmpresa ? [DONO, GERENTE, ESPECIALISTA] : [DONO],
                            placement: 'left',
                            menu: true,
                            route: '/gerenciamento-leads-removidos'
                        }
                    },

                {
                        parent: '#left-sidebar-nav',
                        target: '#cadastro-cliente',
                        content: 'Para cadastrar um lead, basta no menu Cliente clicar em <b>Cadastro</b>!',
                        params: { cargos: [DONO, CORRETOR, LIDER, PARCEIRO],
                            placement: 'left',
                            menu: true, //duvidoso e seu irmao tb
                            route: '/cliente/cadastro',
                            subMenu: true,
                            subMenuTarget:"#group-cliente"
                        }
                    },
                {
                    parent: '#left-sidebar-nav',
                    target: '#removidos',
                    content: 'Para vermos os Leads que foram excluídos, basta no menu clicar em <b>Leads removidos</b>!',
                     params: { cargos: isMultiEmpresa ? [DONO, GERENTE, ESPECIALISTA] : [DONO],
                        placement: 'left',
                        menu: true,
                        route: '/gerenciamento-leads-removidos'
                    }
                },

               {
                    parent: '#left-sidebar-nav',
                    target: '#cadastro-cliente',
                    content: 'Para cadastrar um lead, basta no menu Cliente clicar em <b>Cadastro</b>!',
                    params: { cargos: [CORRETOR, ESPECIALISTA, LIDER, PARCEIRO, GERENTE],
                        placement: 'left',
                        menu: true,
                        route: '/cliente/cadastro',
                        subMenu: true,
                        subMenuTarget:"#group-cliente"
                    }
                },
                 {
                    parent: '',
                    target: '',
                    content: '',
                    params: { cargos: [DONO, CORRETOR, ESPECIALISTA, LIDER, PARCEIRO, GERENTE],
                        placement: 'left',
                        menu: false,
                        // route: '/gerenciamento-leads'
                    }
                },

                ],

        }),
        components: {
            Tarefas,
            TituloPagina,
            Acompanhamento,
            InformacoesAdicionais,
            CardInfo,
            Datepicker,
            MyTour,
            Anexo

        },
        mounted() {
            $(this.$refs.tab).tabs();
        },
        created() {
            this.steps = TourHelper.createSteps(this.steps);
            // console.log(enjoyhint_instance)
            this.usuarioLogadoCargo = Auth.getCargoUsuario();
            this.cargoDono = DONO;
            this.cargoGerente = GERENTE;
            this.cargoCorretor = CORRETOR;
            this.cargoEspecialista = ESPECIALISTA;
            this.cargoLider = LIDER;
            this.cargoParceiro = PARCEIRO;

            let self = this;
            self.showLoading();
            get('pedido/'+this.$route.params.pedidoId).then(function (response) {
                self.item = response.data.result.data;
                self.showItem = true;
                self.hideLoading();

                // tour
                if(self.item.pedido_visita_avulsas.length !== 0 && self.item.pedido_contato_avulsos.length !== 0){
                    const newsSteps = [
                        {
                            parent: '.colConsultor:eq(0)',
                            target: '.colConsultor',
                            content: 'Consultor responsável pelo Lead',
                            params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                                placement: 'bottom',
                                menu: false
                            }
                        },
                        {
                            parent: '.colTipo:eq(0)',
                            target: '.colTipo',
                            content: 'Qual etapa da esteira ele passou',
                            params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                                placement: 'bottom',
                                menu: false
                            }
                        },
                        {
                            parent: '.colData:eq(0)',
                            target: '.colData',
                            content: 'Qual a data e hora que que ele fez contato ou realizou uma visita! (Consultor que informa essa hora)',
                            params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                                placement: 'bottom',
                                menu: false
                            }
                        },
                        {
                            parent: '.colEmpresa:eq(0)',
                            target: '.colEmpresa',
                            content: 'Empresa responsável pelo atendimento do Lead!',
                            params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                                placement: 'bottom',
                                menu: false
                            }
                        },
                        {
                            parent: '.colObs:eq(0)',
                            target: '.colObs',
                            content: 'Observações que foram relatadas pelo consultor no momento de preencher os dados da fase!',
                            params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                                placement: 'bottom',
                                menu: false
                            }
                        },
                        {
                            parent: '.colStatus:eq(0)',
                            target: '.colStatus',
                            content: 'Se o contato, visita ou negociação foram realizados com sucesso ou se houve algum impedimento!',
                            params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                                placement: 'bottom',
                                menu: false
                            }
                        },
                        {
                            parent: '.colAcoes:eq(0)',
                            target: '.colAcoes',
                            content: 'Aqui é possivel voltar estágios e adicionar comentários!',
                            params: { cargos: [DONO, PARCEIRO, GERENTE, ESPECIALISTA],
                                placement: 'bottom',
                                menu: false
                            }
                        },


                    ];
                    self.steps = self.steps.concat(newsSteps);
                }


                // console.log(9999999, self.steps);

                 self.mountData();

            });
        },
        watch:{
            item(){
                this.mountData();
            }
        },
        methods: {
            mountData(){
                const self = this;
                 let order = {
                1: {
                    order: 0,
                    icon: 'person',
                    color: 'gradient-45deg-amber-amber',
                    secondColor: 'blue-aqua-light'
                },
                2: {
                    order: 1,
                    icon: 'perm_phone_msg',
                    color: 'gradient-45deg-purple-deep-purple',
                    secondColor: 'pink-light'
                },
                3: {
                    order: 2,
                    icon: 'perm_contact_calendar',
                    color: 'gradient-45deg-light-blue-cyan',
                    secondColor: 'yellow-light'
                },
                9: {
                    order: 3,
                    icon: 'attach_money',
                    color: 'gradient-45deg-purple-light-blue',
                    secondColor: 'blue-light'
                },
                4: {
                    order: 4,
                    icon: 'check',
                    color: 'gradient-45deg-green-teal',
                    secondColor: 'green-light'
                },
                5: {
                    order: 5,
                    icon: 'close',
                    color: 'gradient-45deg-red-pink',
                    secondColor: 'red'
                },
                6: {
                    order: 6,
                    icon: 'play_circle_filled',
                    color: 'gradient-45deg-orange-light',
                    secondColor: 'orange-light'
                },
                8: {
                    order: 6,
                    icon: 'warning',
                    color: 'gradient-45deg-red-pink',
                    secondColor: 'red'
                },
                7: {
                    order: 7,
                    icon: 'hourglass_empty',
                    color: 'gradient-45deg-indigo-light-blue',
                    secondColor: 'blue darken-4'
                },
            };


            let ordens = [
                'indicacao',
                'contatoTelefonico',
                'visita',
                'negociacao',
                'efetivado',
                'negativado'
            ];

            let icons = [
                'alarm',
                'perm_phone_msg',
                'perm_contact_calendar',
                'attach_money',
                'check',
                'close'
            ];

            let colors = [
                'gradient-45deg-amber-amber',
                'gradient-45deg-purple-deep-purple',
                'gradient-45deg-brown-brown',
                'gradient-45deg-purple-light-blue',
                'gradient-45deg-green-teal',
                'gradient-45deg-red-pink'
            ];

            self.item.pedido_visita_avulsas.forEach(function (value) {
                    // mapeamento generico
                    // debugger;
                    value.map_pessoa            = {
                        nome: value.funcionario ? value.funcionario.pessoa.pessoa_nome : false,
                        avatar: value.funcionario ? value.funcionario.pessoa.pessoa_avatar : false,
                    };
                    value.map_tipo              = ConverterHelper.getStatusName(value.pedido_estagio.pedido_estagio_nome);
                    value.map_datas             = self.getData(value.pedido_visita_avulsa_data);
                    value.map_funcionario       = {
                        empresa: value.funcionario.empresa.empresa_nome_fantasia,
                        cargo: value.funcionario.funcionario_cargo.funcionario_cargo_nome,
                    };
                    value.map_observacoes       = value.pedido_visita_avulsa_observacoes;
                    value.map_status            = self.getVisitaStatus(value.pedido_visita_avulsa_estado_id);
                    value.map_acoes             = false;
                    value.map_historico_observacoes = [];
                    // fim mapeamento
            });

            self.item.pedido_contato_avulsos.forEach(function (value) {
                // mapeamento generico
                value.map_pessoa            = {
                    nome: value.funcionario ? value.funcionario.pessoa.pessoa_nome : false,
                    avatar: value.funcionario ? value.funcionario.pessoa.pessoa_avatar : false,
                };
                value.map_tipo              = ConverterHelper.getStatusName(value.pedido_estagio.pedido_estagio_nome);
                value.map_datas             = self.getData(value.pedido_contato_avulso_data);
                value.map_funcionario       = {
                    empresa: value.funcionario.empresa.empresa_nome_fantasia,
                    cargo: value.funcionario.funcionario_cargo.funcionario_cargo_nome,
                };
                // debugger;
                value.map_observacoes       = value.pedido_contato_avulso_observacoes;
                value.map_status            = value.pedido_contato_avulso_estado_id == 1 ? 'Efetuado com sucesso': self.getContatoStatus(value.pedido_contato_avulso_estado_id);
                value.map_acoes             = false;
                value.map_historico_observacoes = [];
                // fim mapeamento
            });

            self.item.pedido_historicos.forEach(function (value) {

                value.statusDescription = '';

                for (let index in order) {
                    if (value.pedido_estagio_id == index) {
                        value.ordem =  order[index].order;
                        value.icon = order[index].icon;
                        value.color = order[index].color;
                        value.secondColor = order[index].secondColor;

                        switch (value.pedido_estagio_id) {
                            case 1:
                                value.statusDescription = 'Efetuado e agendado';
                                break;
                            case 2:
                                value.statusDescription = 'Não atendeu';
                            break;
                            case 3:
                                value.statusDescription = 'Telefone ocupado';
                            break;
                            case 4:
                                value.statusDescription = 'Telefone não existe';
                            break;
                            case 5:
                                value.statusDescription = 'Telefone desligado';
                            break;
                            case 6:
                                value.statusDescription = 'Efetuado com retorno';
                            break;
                            case 7:
                                value.statusDescription = 'Em processo de análise da seguradora';
                            break;
                        }


                        if (value.pedido_estagio_id == ESTAGIO_PROSPECCAO) {
                            // console.log(value);
                            value.description = '<div class="row"><div class="col m6"><b>Data da indicação:</b> '+self.getData(value.data_criacao)+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Empresa/Cargo responsável</b> '+value.funcionario.empresa.empresa_nome_fantasia+'/'+value.funcionario.funcionario_cargo.funcionario_cargo_nome+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Observações:</b> '+self.item.cliente_has_produto.cliente.pessoa.pessoa_observacao+'</div></div>';
                            value.pedido_historico_observacoes.forEach(function (obj) {
                                value.description += '<div class="row"><div class="col m12"><b>'+obj.funcionario.pessoa.pessoa_nome+':</b> '+self.checkReturn(obj.pedido_historico_observacoes_comentario)+'</div></div>'
                                value.observacoes += self.checkReturn(obj.pedido_historico_observacoes_comentario)+' ';
                            });
                        } else if (value.pedido_estagio_id == ESTAGIO_CHAMADA_TELEFONICA) {
                            let statusContato = '';
                            switch (value.pedido_contato_estado_id) {
                                case 1:
                                    statusContato = 'Efetuado e agendado';
                                break;
                                case 2:
                                    statusContato = 'Não atendeu';
                                break;
                                case 3:
                                    statusContato = 'Telefone ocupado';
                                break;
                                case 4:
                                    statusContato = 'Telefone não existe';
                                break;
                                case 5:
                                    statusContato = 'Telefone desligado';
                                break;
                                case 6:
                                    statusContato = 'Efetuado com retorno';
                                break;
                                case 7:
                                    statusContato = 'Não possui mais interesse';
                                break;
                            }
                            value.statusContato = statusContato;
                            value.statusDescription = statusContato;
                            value.description = '<div class="row"><div class="col m6"><b>Data do contato:</b> '+self.getData(value.pedido_contato_data)+'</div>' +
                                '<div class="col m6"><b>Status do contato:</b> '+statusContato+'</div></div>' +
                                '<div class="row"><div class="col m6"><b>Tipo:</b> '+value.pedido_contato_tipo+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Empresa/Cargo responsável</b> '+value.funcionario.empresa.empresa_nome_fantasia+'/'+value.funcionario.funcionario_cargo.funcionario_cargo_nome+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Observações:</b> '+self.checkReturn(value.pedido_contato_observacoes)+'</div></div>';
                            value.pedido_historico_observacoes.forEach(function (obj) {
                                value.description += '<div class="row"><div class="col m12"><b>'+obj.funcionario.pessoa.pessoa_nome+':</b> '+obj.pedido_historico_observacoes_comentario+'</div></div>'
                                value.observacoes += self.checkReturn(obj.pedido_historico_observacoes_comentario)+' ';
                            })
                        } else if (value.pedido_estagio_id == ESTAGIO_PRIMEIRA_VISITA) {
                            let statusVisita = '';
                            switch (value.pedido_visita_estado_id) {
                                case 1:
                                    statusVisita = 'Marcação';
                                    break;
                                case 2:
                                    statusVisita = 'Efetuada com sucesso';
                                    break;
                                case 3:
                                    statusVisita = 'Remarcada';
                                    break;
                                case 4:
                                    statusVisita = 'Não estava presente';
                                    break;
                                case 5:
                                    statusVisita = 'Cancelada';
                            }
                            let statusContato = '';
                            switch (value.pedido_contato_estado_id) {
                                case 1:
                                    statusContato = 'Efetuado e agendado';
                                break;
                                case 2:
                                    statusContato = 'Não atendeu';
                                break;
                                case 3:
                                    statusContato = 'Telefone ocupado';
                                break;
                                case 4:
                                    statusContato = 'Telefone não existe';
                                break;
                                case 5:
                                    statusContato = 'Telefone desligado';
                                break;
                                case 6:
                                    statusContato = 'Efetuado com retorno';
                                break;
                                case 7:
                                    statusContato = 'Não possui mais interesse';
                                break;
                            }
                            if (statusVisita != '') {
                                value.statusDescription = statusVisita;
                            }
                            else {
                                value.statusDescription = statusContato;
                            }
                            value.description = '<div class="row"><div class="col m6"><b>Data marcada:</b> '+self.getData(value.pedido_visita_data)+'</div>' +
                                '<div class="col m6"><b>Status da visita:</b> '+statusVisita+'</div></div>' +
                                '<div class="row"><div class="col m6"><b>Tipo:</b> '+value.pedido_visita_tipo+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Empresa/Cargo responsável</b> '+value.funcionario.empresa.empresa_nome_fantasia+'/'+value.funcionario.funcionario_cargo.funcionario_cargo_nome+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Observações:</b> '+self.checkReturn(value.pedido_visita_observacoes)+'</div></div>';
                            if (value.pedido_historico_agendas[0]) {
                                value.description += '<div class="row"><div class="col m12"><b>Endereço:</b> '+self.checkReturn(value.pedido_historico_agendas[0].pedido_historico_agenda_endereco)+'</div></div>'
                            }
                            value.pedido_historico_observacoes.forEach(function (obj) {
                                value.description += '<div class="row"><div class="col m12"><b>'+obj.funcionario.pessoa.pessoa_nome+':</b> '+self.checkReturn(obj.pedido_historico_observacoes_comentario)+'</div></div>'
                                value.observacoes += self.checkReturn(obj.pedido_historico_observacoes_comentario)+' ';
                            })
                        } else if (value.pedido_estagio_id == ESTAGIO_SEGUNDA_VISITA) {
                            let statusVisita = '';
                            switch (value.pedido_visita_estado_id) {
                                case 1:
                                    statusVisita = 'Marcação';
                                    break;
                                case 2:
                                    statusVisita = 'Efetuada com sucesso';
                                    break;
                                case 3:
                                    statusVisita = 'Remarcada';
                                    break;
                                case 4:
                                    statusVisita = 'Não estava presente';
                                    break;
                                case 5:
                                    statusVisita = 'Cancelada';
                            }
                            let statusContato = '';
                            switch (value.pedido_contato_estado_id) {
                                case 1:
                                    statusContato = 'Efetuado e agendado';
                                break;
                                case 2:
                                    statusContato = 'Não atendeu';
                                break;
                                case 3:
                                    statusContato = 'Telefone ocupado';
                                break;
                                case 4:
                                    statusContato = 'Telefone não existe';
                                break;
                                case 5:
                                    statusContato = 'Telefone desligado';
                                break;
                                case 6:
                                    statusContato = 'Efetuado com retorno';
                                break;
                                case 7:
                                    statusContato = 'Não possui mais interesse';
                                break;
                            }
                            if (statusVisita != '') {
                                value.statusDescription = statusVisita;
                            }
                            else {
                                value.statusDescription = statusContato;
                            }
                            value.description = '<div class="row"><div class="col m6"><b>Data marcada:</b> '+self.getData(value.pedido_visita_data)+'</div>' +
                                '<div class="col m6"><b>Status da visita:</b> '+statusVisita+'</div></div>' +
                                '<div class="row"><div class="col m6"><b>Tipo:</b> '+value.pedido_visita_tipo+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Empresa/Cargo responsável</b> '+value.funcionario.empresa.empresa_nome_fantasia+'/'+value.funcionario.funcionario_cargo.funcionario_cargo_nome+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Observações:</b> '+self.checkReturn(value.pedido_visita_observacoes)+'</div></div>';
                            if (value.pedido_historico_agendas[0]) {
                                value.description += '<div class="row"><div class="col m12"><b>Endereço:</b> '+self.checkReturn(value.pedido_historico_agendas[0].pedido_historico_agenda_endereco)+'</div></div>'
                            }
                            value.pedido_historico_observacoes.forEach(function (obj) {
                                value.description += '<div class="row"><div class="col m12"><b>'+obj.funcionario.pessoa.pessoa_nome+':</b> '+self.checkReturn(obj.pedido_historico_observacoes_comentario)+'</div></div>'
                                value.observacoes += self.checkReturn(obj.pedido_historico_observacoes_comentario)+' ';
                            })
                        } else if (value.pedido_estagio_id == ESTAGIO_EFETIVADO) {
                            let obs = value.pedido_efetivado_observacao;
                            if (obs === null) {
                                obs = '';
                            }
                            value.description = '<div class="row"><div class="col m6"><b>Data efetivação:</b> '+self.getData(value.data_criacao)+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Empresa/Cargo responsável</b> '+value.funcionario.empresa.empresa_nome_fantasia+'/'+value.funcionario.funcionario_cargo.funcionario_cargo_nome+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Observações:</b> '+self.checkReturn(obs)+'</div></div>';
                            value.pedido_historico_observacoes.forEach(function (obj) {
                                value.description += '<div class="row"><div class="col m12"><b>'+obj.funcionario.pessoa.pessoa_nome+':</b> '+self.checkReturn(obj.pedido_historico_observacoes_comentario)+'</div></div>'
                                value.observacoes += self.checkReturn(obj.pedido_historico_observacoes_comentario)+' ';
                            })
                        } else if (value.pedido_estagio_id == ESTAGIO_EM_ESPERA) {
                            let obs = value.pedido_cold_observacao
                            console.log(value, 'cold')
                            if (obs === null) {
                                obs = '';
                            }
                            value.description = '<div class="row"><div class="col m6"><b>Data de sinalização:</b> '+self.getData(value.data_criacao)+'</div>' +
                                '<div class="col m6"><b>Data de retorno:</b> '+self.getData(value.pedido_cold_data_retorno)+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Empresa/Cargo responsável</b> '+value.funcionario.empresa.empresa_nome_fantasia+'/'+value.funcionario.funcionario_cargo.funcionario_cargo_nome+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Observações:</b> '+obs+'</div></div>';
                            value.pedido_historico_observacoes.forEach(function (obj) {
                                value.description += '<div class="row"><div class="col m12"><b>'+obj.funcionario.pessoa.pessoa_nome+':</b> '+self.checkReturn(obj.pedido_historico_observacoes_comentario)+'</div></div>'
                                value.observacoes += self.checkReturn(obj.pedido_historico_observacoes_comentario)+' ';

                            })
                        } else if (value.pedido_estagio_id == ESTAGIO_PERDIDO) {
                            let obs = value.pedido_lost_observacao;
                            if (obs === null) {
                                obs = '';
                            }

                            let statusLost = '';
                            switch (value.pedido_lost_motivo) {
                                case 1:
                                    statusLost = 'Negativado com sucesso';
                                    break;
                            }
                            value.description = '<div class="row"><div class="col m6"><b>Data de sinalização:</b> '+self.getData(value.data_criacao)+'</div>' +
                                '<div class="col m6"><b>Motivo:</b> '+statusLost+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Empresa/Cargo responsável</b> '+value.funcionario.empresa.empresa_nome_fantasia+'/'+value.funcionario.funcionario_cargo.funcionario_cargo_nome+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Observações:</b> '+self.checkReturn(obs)+'</div></div>';
                            value.pedido_historico_observacoes.forEach(function (obj) {
                                value.description += '<div class="row"><div class="col m12"><b>'+obj.funcionario.pessoa.pessoa_nome+':</b> '+self.checkReturn(obj.pedido_historico_observacoes_comentario)+'</div></div>'
                                value.observacoes += self.checkReturn(obj.pedido_historico_observacoes_comentario)+' ';
                            })
                        } else if (value.pedido_estagio_id == ESTAGIO_NEGATIVADO) {
                            let obs = value.pedido_nao_efetivado_observacao;
                            if (obs === null) {
                                obs = '';
                            }

                            let statusLost = '';
                            switch (value.pedido_nao_efetivado_motivo) {
                                case 1:
                                    statusLost = 'Negativado com sucesso';
                                    break;
                            }
                            value.description = '<div class="row"><div class="col m6"><b>Data negativação:</b> '+self.getData(value.data_criacao)+'</div>' +
                                '<div class="col m6"><b>Motivo:</b> '+statusLost+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Empresa/Cargo responsável</b> '+value.funcionario.empresa.empresa_nome_fantasia+'/'+value.funcionario.funcionario_cargo.funcionario_cargo_nome+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Observações:</b> '+self.checkReturn(obs)+'</div></div>';
                            value.pedido_historico_observacoes.forEach(function (obj) {
                                value.description += '<div class="row"><div class="col m12"><b>'+obj.funcionario.pessoa.pessoa_nome+':</b> '+self.checkReturn(obj.pedido_historico_observacoes_comentario)+'</div></div>'
                                value.observacoes += self.checkReturn(obj.pedido_historico_observacoes_comentario)+' ';
                            })
                        } else if (value.pedido_estagio_id == ESTAGIO_NEGOCIACAO) {
                            let statusVisita = '';
                            switch (value.pedido_visita_estado_id) {
                                case 1:
                                    statusVisita = 'Marcação';
                                    break;
                                case 2:
                                    statusVisita = 'Efetuada com sucesso';
                                    break;
                                case 3:
                                    statusVisita = 'Remarcada';
                                    break;
                                case 4:
                                    statusVisita = 'Não estava presente';
                                    break;
                                case 5:
                                    statusVisita = 'Cancelada';
                            }
                            let statusContato = '';
                            switch (value.pedido_contato_estado_id) {
                                case 1:
                                    statusContato = 'Efetuado e agendado';
                                break;
                                case 2:
                                    statusContato = 'Não atendeu';
                                break;
                                case 3:
                                    statusContato = 'Telefone ocupado';
                                break;
                                case 4:
                                    statusContato = 'Telefone não existe';
                                break;
                                case 5:
                                    statusContato = 'Telefone desligado';
                                break;
                                case 6:
                                    statusContato = 'Efetuado com retorno';
                                break;
                                case 7:
                                    statusContato = 'Não possui mais interesse';
                                break;
                            }
                            if (statusVisita != '') {
                                value.statusDescription = statusVisita;
                            }
                            else {
                                value.statusDescription = statusContato;
                            }
                            value.description = '<div class="row"><div class="col m6"><b>Data início:</b> '+self.getData(value.data_criacao)+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Empresa/Cargo responsável</b> '+value.funcionario.empresa.empresa_nome_fantasia+'/'+value.funcionario.funcionario_cargo.funcionario_cargo_nome+'</div></div>' +
                                '<div class="row"><div class="col m12"><b>Observações:</b> Em negociação</div></div>';
                            value.pedido_historico_observacoes.forEach(function (obj) {
                                value.description += '<div class="row"><div class="col m12"><b>'+obj.funcionario.pessoa.pessoa_nome+':</b> '+self.checkReturn(obj.pedido_historico_observacoes_comentario)+'</div></div>'
                                value.observacoes += self.checkReturn(obj.pedido_historico_observacoes_comentario)+' ';
                            })
                        }

                    }
                }

                value.map_pessoa            = {
                    nome: value.funcionario ? value.funcionario.pessoa.pessoa_nome : false,
                    avatar: value.funcionario ? value.funcionario.pessoa.pessoa_avatar : false,
                };
                value.map_tipo              = ConverterHelper.getStatusName(value.pedido_estagio.pedido_estagio_nome);
                value.map_datas             = self.getData(value.data_criacao);
                value.map_funcionario       = {
                    empresa: value.funcionario ? value.funcionario.empresa.empresa_nome_fantasia : false,
                    cargo: value.funcionario ? value.funcionario.funcionario_cargo.funcionario_cargo_nome : false,
                };
                value.map_observacoes       = value.pedido_historico_comentario;
                if(value.map_tipo.toLowerCase().includes('negativado')){
                    value.map_status            = 'Negativado com sucesso';
                }
                else if(value.map_tipo.toLowerCase().includes('efetivado')){
                    value.map_status            = 'Efetivado com sucesso';
                }
                else {
                    value.map_status            = value.statusDescription;
                }

                value.map_acoes             = true;
                value.map_historico_observacoes = value.pedido_historico_observacoes;
                // fim mapeamento
            }, this);

            // self.acompanhamentoListagem = self.showAcompanhamento([].concat(self.item.pedido_historicos, self.item.pedido_contato_avulsos, self.item.pedido_visita_avulsas));
            self.acompanhamentoListagem = self.showAcompanhamento(self.item.pedido_historicos);

            },
             getData(data) {
                return moment(data).format('DD/MM/YYYY HH:mm');
            },
            getContatoStatus(id) {
                switch (id) {
                    case 1:
                        return 'Efetuado e agendado';
                    case 2:
                        return 'Não atendeu';
                    case 3:
                        return 'Telefone ocupado';
                    case 4:
                        return 'Telefone não existe';
                    case 5:
                        return 'Telefone desligado';
                    case 6:
                        return 'Efetuado com retorno';
                    case 7:
                        return 'Não possui mais interesse';
                }
            },
            getVisitaStatus(id) {
                switch (id) {
                    case 1:
                        return 'Marcação';
                    case 2:
                        return 'Efetuada com sucesso';
                    case 3:
                        return 'Remarcada';
                    case 4:
                        return 'Não estava presente';
                    case 5:
                        return 'Cancelada';
                }
            },
             checkReturn(string) {
                if (string) {
                    return string;
                }
                return '';
            },
            clearField(){
                this.checkUsuariosAgenda = [];
                this.funcionarioFiltro   = '';
            },
            checaCargoUsuario(cargoMono, cargoMulti){
              return checaCargo(cargoMono, cargoMulti)
            },
            checarCurrent(arrayId) {
                if (typeof this.item.pedido_historico === 'undefined') {
                    return false;
                }
                return arrayId.indexOf(this.item.pedido_historico.pedido_estagio_id) !== -1;
            },
            atualizaPedido(e) {
                [this.item] = e;
            },
            customFormatter(date) {
                return moment(date).format('DD/MM/YYYY');
            },
            showAcompanhamento(data){
                const newObject = [].concat(data);

                return newObject.sort((data1 , data2) => {
                    const m1 = moment(data1.data_criacao);
                    const m2 = moment(data2.data_criacao);

                    if(m1 > m2){
                        return 1;
                    }
                    else{
                        return -1;
                    }
                    return 0;

                }).reverse();
            },
            congelarPedido() {
                let validForm = true;
                if (this.congelar.dataRetorno === '') {
                    Message.messageError('Preencha a data de retorno.');
                    validForm = false;
                }
                if (this.congelar.observacao === '') {
                    Message.messageError('Preencha a observação.');
                    validForm = false;
                }
                if (! validForm) {
                    return false;
                }

                let self = this;
                self.showLoading();
                post('processo/cold', {
                    pedido_id: this.item.pedido_id,
                    pedido_cold_data_retorno: this.congelar.dataRetorno,
                    pedido_cold_observacao: this.congelar.observacao
                }).then(function (response) {
                    self.$emit('atualiza', [
                        response.data.result.data
                    ]);
                    self.congelar = {
                        dataRetorno: '',
                        observacao: ''
                    };
                    Message.messageSuccess('Cliente sinalizado como EM ESPERA com sucesso.');
                    $('#modal1').modal('close');

                    self.hideLoading();
                    // self.$router.push('/gerenciamento-leads');
                    self.$router.go();
                });
            },
            lostPedido() {
                let validForm = true;
                if (this.lost.motivo === '') {
                    Message.messageError('Preencha o motivo.');
                    validForm = false;
                }
                if (this.lost.observacao === '') {
                    Message.messageError('Preencha a observação.');
                    validForm = false;
                }
                if (! validForm) {
                    return false;
                }

                let self = this;
                self.showLoading();
                post('processo/lost', {
                    pedido_id: this.item.pedido_id,
                    pedido_lost_motivo: this.lost.motivo,
                    pedido_lost_observacao: this.lost.observacao
                }).then(function (response) {
                    self.$emit('atualiza', [
                        response.data.result.data
                    ]);
                    self.lost = {
                        motivo: '',
                        observacao: ''
                    };
                    Message.messageSuccess('Cliente sinalizado como PERDIDO');
                    $('#modalLost').modal('close');

                    self.hideLoading();
                    // self.$router.push('/gerenciamento-leads');
                    self.$router.go();
                });
            },
            abreModalLost() {
                setTimeout(function () {
                    $('#modalLost').modal();
                    $('#modalLost').modal('open');
                }, 500);
            },
            abreModalCold() {
                setTimeout(function () {
                    $('#modal1').modal();
                    $('#modal1').modal('open');
                }, 500);
            },
            checaMostrarBotoes() {
                if (typeof this.item === 'undefined' ||
                    typeof this.item.pedido_historico === 'undefined'
                ) {
                    return false;
                }

                if ([ESTAGIO_NEGATIVADO, ESTAGIO_EFETIVADO, ESTAGIO_EM_ESPERA, ESTAGIO_PERDIDO].indexOf(this.item.pedido_historico.pedido_estagio_id) !== -1) {
                    return false;
                } else {
                    return true;
                }
            },
            showLoading () {
                this.$parent.$emit('showLoading', true);
            },
            hideLoading () {
                this.$parent.$emit('showLoading', false);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/lead/GerenciamentoLead.vue